import { render } from "./Completion.vue?vue&type=template&id=b8648f04&scoped=true&ts=true"
import script from "./Completion.vue?vue&type=script&lang=ts"
export * from "./Completion.vue?vue&type=script&lang=ts"

import "./Completion.vue?vue&type=style&index=0&id=b8648f04&scoped=true&lang=scss"
import "./Completion.vue?vue&type=style&index=1&id=b8648f04&lang=scss"

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8648f04"]])

export default __exports__